import React from 'react'
import { labels } from '../../../labels'
import Text from '../../text/Text'
import styles from './ConfirmModal.module.css'
import iconClock from '../../../assets/icons/icons-success-clock.svg'

interface IInconrrectCredentialsProps {
    onClick: () => void
    onBack: () => void
}

export default function ConfirmModal(props: IInconrrectCredentialsProps) {
    return (
        <div className={styles.confirmModal}>
            <div className={styles.labels}>
                <img src={iconClock} />
                <Text
                    label={`${labels.confirmLiquidate} ${labels.amipass}`}
                    fontSize={16}
                    color="#656565"
                    fontWeight={500}
                    textAlign="center"
                    marginTop={20}
                />
                <Text
                    label={labels.confirmPublish}
                    fontSize={16}
                    color="#656565"
                    fontWeight={700}
                    marginTop={10}
                />
            </div>
            <div className={styles.buttons}>
                <button
                    className={`modalButtonBack sm13 ${styles.button}`}
                    onClick={props.onBack}
                    type="button"
                >
                    {labels.back}
                </button>
                <button
                    className={`modalButtonBack sm13 successBC ${styles.button}`}
                    onClick={props.onClick}
                    style={{ height: 36 }}
                    type="button"
                >
                    Publicar
                </button>
            </div>
        </div>
    )
}
